// Simple Quantity Buttons with Max Inventory Check
// Basic plus/minus with inventory limits - Scoped to individual product cards

console.log('🔧 Quantity Buttons JS Loaded');

document.addEventListener('DOMContentLoaded', function() {
    console.log('📦 DOM Content Loaded - Initializing Quantity Buttons');

    // Simple event delegation for all quantity buttons
    document.addEventListener('click', function(event) {
        const button = event.target.closest('.btn-quantity');
        if (!button) return;

        console.log('🔘 Button clicked:', button.className, button.name);
        event.preventDefault();

        // Find the product card/item container first (try multiple selectors)
        const productCard = button.closest('.product-item, .card, [data-product-item], [data-product-card], form.variants, [data-product-id]');
        console.log('🏷️ Found product card:', productCard);

        if (!productCard) {
            console.error('❌ No product card container found');
            return;
        }

        // Then find the quantity input within this specific product card
        const input = productCard.querySelector('input[name="quantity"], input.quantity');
        //console.log('📝 Found input:', input);

        if (!input) {
            console.error('❌ No quantity input found in product card');
            return;
        }

        let currentValue = parseInt(input.value) || 1;
        const maxInventory = parseInt(input.dataset.inventoryQuantity) || 999;

        console.log('📊 Current value:', currentValue, 'Max inventory:', maxInventory);

        // Simple plus/minus logic with inventory check
        if (button.classList.contains('plus') || button.name === 'plus') {
            if (currentValue < maxInventory) {
                currentValue += 1;
                console.log('➕ Increased to:', currentValue);
            } else {
                // Optional: Show warning when hitting max
                showSimpleWarning(`Maximum quantity is ${maxInventory}`);
                console.log('🚫 Hit max inventory limit');
                return;
            }
        } else if (button.classList.contains('minus') || button.name === 'minus') {
            currentValue = Math.max(1, currentValue - 1); // Don't go below 1
            console.log('➖ Decreased to:', currentValue);
        }

        // Update the input value
        input.value = currentValue;
        console.log('💾 Updated input value to:', currentValue);

        // Dispatch change event for any other listeners
        input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Also handle direct input changes to ensure minimum of 1 and max inventory
    document.addEventListener('input', function(event) {
        const input = event.target;
        if (input.name === 'quantity' || input.classList.contains('quantity')) {
            let value = parseInt(input.value) || 1;
            const maxInventory = parseInt(input.dataset.inventoryQuantity) || 999;

            if (value < 1) {
                input.value = 1;
            } else if (value > maxInventory) {
                input.value = maxInventory;
                showSimpleWarning(`Maximum quantity is ${maxInventory}`);
            }
        }
    });

    // Also handle change events for validation
    document.addEventListener('change', function(event) {
        const input = event.target;
        if (input.name === 'quantity' || input.classList.contains('quantity')) {
            let value = parseInt(input.value) || 1;
            const maxInventory = parseInt(input.dataset.inventoryQuantity) || 999;

            if (value < 1) {
                input.value = 1;
            } else if (value > maxInventory) {
                input.value = maxInventory;
                showSimpleWarning(`Maximum quantity is ${maxInventory}`);
            }
        }
    });
});

// Simple warning function
function showSimpleWarning(message) {
    // Try to use existing warning system if available
    if (typeof showWarning === 'function') {
        showWarning(message, 3000);
    } else {
        // Fallback: simple alert or console log
        console.log('Quantity Warning:', message);
        // You can replace this with a custom notification system
        // alert(message);
    }
}

// Fallback initialization
window.addEventListener('load', function() {
    // Re-run the event listeners in case DOM was modified after initial load
    const quantityButtons = document.querySelectorAll('.btn-quantity');
    quantityButtons.forEach(button => {
        if (!button.hasAttribute('data-initialized')) {
            button.setAttribute('data-initialized', 'true');
        }
    });
});
